import { Profile } from './profile';

export class CurrentUser {
  email?: string;
  token?: string;
  data?: Profile;
}
